import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import Services from "@/pages/Services";
import Engagements from "@/pages/Engagements";
import Villes from "@/pages/Villes";
import Contact from "@/pages/Contact";
import CityPage from "@/pages/cities/CityPage";
import Logos from "@/pages/Logos";
import Mentions from "@/pages/Mentions";
import Resultats from "@/pages/Resultats";
import FAQPage from "@/pages/FAQ";
import PourquoiNous from "@/pages/PourquoiNous";
import MobilHomeDinard from "@/pages/MobilHomeDinard";
import MobilHomeSaintCast from "@/pages/MobilHomeSaintCast";
import MobilHomeAmbon from "@/pages/MobilHomeAmbon";
import Blog from "@/pages/Blog";
import BlogArticle from "@/pages/BlogArticle";
import Parrainage from "@/pages/Parrainage";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Layout>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/services" element={<Services />} />
            <Route path="/engagements" element={<Engagements />} />
            <Route path="/villes" element={<Villes />} />
            <Route path="/villes/:slug" element={<CityPage />} />
            <Route path="/resultats" element={<Resultats />} />
            <Route path="/faq" element={<FAQPage />} />
            <Route path="/pourquoi-nous" element={<PourquoiNous />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/blog/:slug" element={<BlogArticle />} />
            <Route path="/mobil-home-dinard" element={<MobilHomeDinard />} />
            <Route path="/mobil-home-saint-cast" element={<MobilHomeSaintCast />} />
            <Route path="/mobil-home-ambon" element={<MobilHomeAmbon />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/parrainage" element={<Parrainage />} />
            <Route path="/mentions-legales" element={<Mentions />} />
            <Route path="/logos" element={<Logos />} />
            <Route path="*" element={<Home />} />
          </Routes>
        </Layout>
        <Toaster position="top-center" richColors closeButton />
      </BrowserRouter>
    </div>
  );
}

export default App;
